import React from "react"
import { Link } from "gatsby"

const Menu = () => {
  return (
    <ul>
      <li>
        <Link to="/">Accueil</Link>
      </li>
      <li>
        <Link to="/fiches">Fiches</Link>
      </li>
      <li>
        <Link to="/lieux">Lieux</Link>
      </li>
      <li>
        <Link to="/statistiques">Statistiques</Link>
      </li>
    </ul>
  )
}

export default Menu
